import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import BasePackageForm from '../BasePackageForm'

const ProfessionalPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.professionalpackages.createPackage'}>
    <Create>
      <BasePackageForm entity="professionals" />
    </Create>
  </SectionWrapper>
)

export default ProfessionalPackageCreate
